import { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import API from '../../api'
import store from 'store2'
import { toast } from 'react-toastify'

import './vote-for-topic.sass'
import messages from '../../messages'

class VoteForTopic extends Component {
  constructor(props) {
    super(props)

    let votedTopics = store.get('topics') || []

    this.props.topics.forEach((topic) => {
      if(votedTopics.indexOf(topic.id) !== -1) {
        topic.isActive = true
      }
    })

    this.state = {
      topics: this.props.topics,
      suggestionBlockVisible: false,
      newTopic: '',
    }
  }

  updateTopic(topic) {
    const { topics } = this.state
    API(`collections/topics/${topic.id}/${topic.isActive ? 'unlike' : 'like'}/`)
      .put()
      .then(() => {
        topics.forEach((t) => {
          if(topic.id === t.id) {
            t.isActive = !t.isActive
            let votedTopics = store.get('topics') || []

            if(t.isActive) {
              t.number_of_votes++

              try {
                votedTopics.push(t.id)
                store('topics', votedTopics)
              } catch (e) {
                console.error(e)
              }
            } else {
              let filteredArray = votedTopics.filter((val) => val !== t.id)
              store('topics', filteredArray)
              t.number_of_votes--
            }
          }
        })

        this.setState({
          topics,
        })
      })
  }

  submitTopic = () => {
    API('collections/topics/suggest/')
      .post({ title: this.state.newTopic })
      .then(() => {
        this.setState({
          newTopic: '',
          suggestionBlockVisible: false,
        })
        toast.success(
          <FormattedMessage
            id='suggestion_sent'
            defaultMessage='Your suggestion about new topic successfully sent!'
          />
        )
      })
  }

  render() {
    const { intl } = this.props
    const { topics, suggestionBlockVisible, newTopic } = this.state
    return (
      <div className='vote-for-topics'>
        {topics.map((topic) => {
          return (
            <div
              className={`topic-item ${topic.isActive ? 'active' : ''}`}
              onClick={() => this.updateTopic(topic)}
              key={topic.id}
            >
              {topic.title}{' '}
              <span className='count'>{topic.number_of_votes}</span>
            </div>
          )
        })}
        <div className='suggest-topic'>
          <a
            className='suggest-topic__btn'
            onClick={() => {
              this.setState({ suggestionBlockVisible: true })
            }}
          >
            <FormattedMessage
              id='suggest_topic'
              defaultMessage='Suggest topic'
            />
            &nbsp;
            <i className='font-icons right-arrow-icon' />
          </a>
          {suggestionBlockVisible && (
            <div className='suggest-topic__form'>
              <input
                type='text'
                placeholder={intl.formatMessage(messages.topicToSuggest)}
                value={this.state.newTopic}
                onChange={(e) => this.setState({ newTopic: e.target.value })}
              />
              <button
                className='btn-red'
                onClick={this.submitTopic}
                disabled={!newTopic}
              >
                <FormattedMessage id='send' defaultMessage='Send' />
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

VoteForTopic.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(VoteForTopic)
